import { getPermissionsForCoreUploadTypes } from '@repo/csv'
import { createFileRoute } from '@tanstack/react-router'
import { ORDER_SERVICE_UPLOAD_TYPES } from './-upload-types'

export const Route = createFileRoute('/_auth/_modules/_app/core-upload-data/order-service')({
  staticData: {
    title: 'route.coreUploadData.orderService',
    crumb: 'route.coreUploadData.orderService',
    permissions: getPermissionsForCoreUploadTypes(ORDER_SERVICE_UPLOAD_TYPES),
  },
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route, { atLeastOne: true })
  },
})
